import Tooltip from "../../../../../components/bases/tooltips/tooltip.js";


import getText from "../../../../../utils/language.js"
import { GlobalContext } from "../../../../../utils/globalprovider.js";
import "./tabs.css"
import React from "react";

class ParamSlider extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props)

        this.state = {
            value: this.props.value,
            defaultvalue: this.props.value,
        }


        this.handleSliderSettings = this.handleSliderSettings.bind(this);
    }
    handleSliderSettings(event)
    {
        this.setState( {value : event.target.value});
        this.props.onchange(this.props.paramnumber, Number(event.target.value));
        
    }
    render()
    {
        const title = getText(this.props.text.cat, this.props.text.scat, this.context.language);

        
        var tcolor="white";
        var checkdefault = false;
        var defaultvalue = this.props.value;
        if (this.props.coid > 0)
        {
            if ("defaultvalue" in this.props)
            {
                defaultvalue = this.props.defaultvalue;
                checkdefault = true;
            }
        }


        if (checkdefault)
        {
            if (this.state.value != defaultvalue)
                tcolor="#FF9800";
        }

        return(
            <div className ="tabsettingslidertext">
                <table width="100%" border="0">
                    <tr>
                        <td width="30%" style={{color:tcolor}}>{title}</td>
                        <td>

                        <input type="range" min={this.props.min}  
                            className= "sliderSettings"
                            style={{background:"inherit"}} 
                            onInput={this.handleSliderSettings} 
                            onChange={this.handleSliderSettings} 
                            value={this.state.value} 
                            max={this.props.max}
                            step={1}
                        />
                        </td>
                        <td width="20%" style={{color:tcolor}}>{this.state.value}&nbsp;{this.props.unit}</td>
                    </tr>
                </table>
            </div>
        )
    }
}

export default ParamSlider
